<template>
    <v-dialog
        v-model="visible"
        width="900px"
        @click:outside="$emit('close')"
    >
        <v-card class="overflow-hidden">
            <v-icon
                class="close"
                color="primary"
                fab
                @click="$emit('close')"
            >
                mdi-close
            </v-icon>
            <v-row class="fill-height container">
                <v-col cols="12">
                    <div class="item-img text-center">
                        <v-img
                            :src="item.img"
                            height="125"
                            max-width="150"
                            class="mx-auto"
                        />

                        <div class="item-details">
                            <h3>{{ item.name }}</h3>
                            <p class="mb-0">
                                ${{ formatAmount(item.price/400) }} monthly
                            </p>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="item-details px-5">
                        <div
                            v-for="benefit in item.benefits"
                            :key="benefit"
                            class="description py-3"
                        >
                            <p>{{ benefit }}</p>
                        </div>

                        <div class="text-center">
                            <v-btn
                                color="primary"
                                dark
                                depressed
                                style="height: 43px"
                                @click="$emit('selected')"
                            >
                                Select
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            visible: Boolean,
            item: {
                type: Object,
                default: () => ({}),
            },
        },
        data: () => ({
            quantity: 1,
        }),
    };
</script>

<style scoped>
.item-img img {
    width: 150px;
    height: 150px;
}

.close {
    position: absolute;
    right: 0;
    top: 0;
    color: #fff;
    padding: 5px;
    cursor: pointer;
}

.item-details .title h3 {
    color: #232323;
    font-size: 20px;
    line-height: 22px;
    font-weight: 500;
}

.item-details .title p {
    color: #232323;
    font-weight: 400;
    font-size: 18px;
    margin: 0;
}

.item-details .description {
    border-top: 1px solid #e8e8e8;
    line-height: 23px;
    font-weight: 400;
}

.item-details .description p {
    margin: 0;
    padding: 0;
}

</style>
